import React from 'react';
import { Modal as AntModal } from 'antd';
import useBackButtonClose from './useBackButtonClose';

// antd Modal that closes on the device/browser Back button (see useBackButtonClose).
// Modals with closable={false} are deliberately not dismissable, so Back is left alone.
const Modal = (props) => {
  const { open, visible, onCancel, closable } = props;
  useBackButtonClose(Boolean(open ?? visible) && Boolean(onCancel) && closable !== false, onCancel);
  return <AntModal {...props} />;
};

// Keep static helpers such as Modal.confirm and Modal.useModal.
Object.assign(Modal, AntModal);

export default Modal;
